<form (ngSubmit)="save()" *ngIf="currency||new" [formGroup]="form">
  <h1 *ngIf="new" class="paragraph-headline" i18n="new currency">New currency</h1>
  <h1 *ngIf="!new && currency" class="paragraph-headline ellipsis" i18n="edit currency">Edit currency <i>"{{getLocalName1(currency)}}"</i></h1>
  <div class="row mb-3">
    <div class="col">
      <app-alerts [alerts]="alerts" [float]="false" [scrollToSubject]="scrollToAlertsSubject"></app-alerts>
    </div>
  </div>
  <div class="row">
    <div class="col-3">
      <mat-form-field class="mat-form-input text-input-100">
        <mat-label i18n="uid">ID</mat-label>
        <input #idRef formControlName="id"
               i18n-placeholder matInput maxlength="{{idMaxLength}}" placeholder="Currency ID"
               required tabindex="0">
        <span class="character-counter">{{idRef.value.length}}/{{idMaxLength}}</span>
      </mat-form-field>

      <mat-form-field class="mat-form-input text-input-100">
        <mat-label i18n="uid">Identifier</mat-label>
        <input #identifierRef formControlName="identifier"
               i18n-placeholder matInput maxlength="{{identifierMaxLength}}" placeholder="Currency identifier"
               required tabindex="0">
        <span class="character-counter">{{identifierRef.value.length}}/{{identifierMaxLength}}</span>
      </mat-form-field>

      <mat-form-field class="mat-form-input text-input-100">
        <mat-label i18n="uid">Symbol</mat-label>
        <input #symbolRef formControlName="symbol"
               i18n-placeholder matInput maxlength="{{symbolMaxLength}}" placeholder="Currency symbol"
               required tabindex="0">
        <span class="character-counter">{{symbolRef.value.length}}/{{symbolMaxLength}}</span>
      </mat-form-field>

    </div>
    <div class="col mb-3">
      <div formArrayName="strings">
        <mat-tab-group [disablePagination]="true" [selectedIndex]="selectedTabIndex" class="no-paging" mat-align-tabs="start">
          <mat-tab *ngFor="let stringsFormGroup of getStringsFormArray().controls; index as stringsIndex"
                   [formGroupName]="stringsIndex">
            <ng-template *ngIf="langRef.value" mat-tab-label>{{langRef.value}}</ng-template>
            <ng-template *ngIf="!langRef.value" i18n="unspecified language" mat-tab-label>Unspecified language</ng-template>

            <div>

              <mat-divider class="py-2"></mat-divider>
              <div class="row ml-3">
                <div class="col-auto">

                  <mat-form-field class="mat-form-input text-input-100">
                    <mat-label i18n="language code">Language code</mat-label>
                    <input #langRef formControlName="lang"
                           matInput maxlength="{{langMaxLength}}"
                           placeholder="Language code" required>
                    <span class="character-counter">{{langRef.value.length}}/{{langMaxLength}}</span>
                  </mat-form-field>

                  <mat-form-field class="mat-form-textarea-w-100">
                    <mat-label i18n="question">Name 0</mat-label>
                    <textarea #name0Ref
                              cdkAutosizeMaxRows="25" cdkAutosizeMinRows="2" cdkTextareaAutosize
                              formControlName="name0" i18n-placeholder="currency name0 input placeholder" matInput
                              maxlength="{{nameMaxLength}}"
                              placeholder="The name for 0 units of this currency." tabindex="3"></textarea>
                    <span class="character-counter">{{name0Ref.value.length}}/{{nameMaxLength}}</span>
                  </mat-form-field>

                  <mat-form-field class="mat-form-textarea-w-100">
                    <mat-label i18n="question">Name 1</mat-label>
                    <textarea #name1Ref
                              cdkAutosizeMaxRows="25" cdkAutosizeMinRows="2" cdkTextareaAutosize
                              formControlName="name1" i18n-placeholder="currency name1 input placeholder" matInput
                              maxlength="{{nameMaxLength}}"
                              placeholder="The name for 1 unit of this currency." tabindex="3"></textarea>
                    <span class="character-counter">{{name1Ref.value.length}}/{{nameMaxLength}}</span>
                  </mat-form-field>

                  <mat-form-field class="mat-form-textarea-w-100">
                    <mat-label i18n="question">Name N</mat-label>
                    <textarea #nameNRef
                              cdkAutosizeMaxRows="25" cdkAutosizeMinRows="2" cdkTextareaAutosize
                              formControlName="nameN" i18n-placeholder="currency nameN input placeholder" matInput
                              maxlength="{{nameMaxLength}}"
                              placeholder="The name for n units of this currency." tabindex="3"></textarea>
                    <span class="character-counter">{{nameNRef.value.length}}/{{nameMaxLength}}</span>
                  </mat-form-field>

                </div>
                <div class="col">
                  <app-mat-icon-button *ngIf="langRef.value !== 'en'" [callback]="translateStrings.bind(this)" [params]="[langRef.value, stringsIndex]"
                                       color="primary" cssClass="mr-2 mb-3" i18n-label="Button label translate strings" icon="translate"
                                       label="Translate en to {{langRef.value}}"
                                       type="button"></app-mat-icon-button>
                  <app-mat-icon-button *ngIf="langRef.value !== 'en'" [breakLabel]="false" [callback]="deleteStrings.bind(this)" [params]="[stringsIndex]"
                                       color="warn" cssClass="mb-3" i18n-label="Button label delete strings" icon="delete" label="Delete {{langRef.value}}"
                                       type="button"></app-mat-icon-button>
                  <app-mat-icon-button *ngIf="langRef.value === 'en' && name0Ref.value && name1Ref.value && nameNRef.value"
                                       [callback]="addMissingTranslations.bind(this)" color="primary" cssClass="mb-3"
                                       i18n-label="Button label add missing translations" icon="translate" label="Add missing translations" tabindex="4"
                                       type="button"></app-mat-icon-button>
                </div>
              </div>
            </div>

          </mat-tab>
        </mat-tab-group>

      </div>

      <span *ngFor="let lang of languages">
        <app-mat-icon-button *ngIf="shouldDisplayLanguage(lang)" [callback]="addStrings.bind(this)" [label]="lang"
                             [params]="[lang]" color="primary" cssClass="mr-2" icon="add"
                             type="button"></app-mat-icon-button>
      </span>
      <app-mat-icon-button [callback]="addStrings.bind(this)" color="primary" cssClass="m-1"
                           i18n-label="other" icon="add" label="other"
                           type="button"></app-mat-icon-button>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <app-mat-icon-button [disabled]="!this.form.valid" [label]="getCreateOrSaveLabel()" cssClass="mb-3 mr-2" icon="save"
                           type="submit"></app-mat-icon-button>

      <app-mat-icon-button [callback]="onDelete.bind(this)" [disabled]="new" [params]="[currency]" color="warn" cssClass="mb-3"
                           i18n-label="delete" icon="delete" label="Delete" type="button"></app-mat-icon-button>
    </div>
  </div>
</form>
